import { render, staticRenderFns } from "./RoomEscape.vue?vue&type=template&id=4b5a8914&scoped=true&"
import script from "./RoomEscape.vue?vue&type=script&lang=js&"
export * from "./RoomEscape.vue?vue&type=script&lang=js&"
import style0 from "./RoomEscape.vue?vue&type=style&index=0&id=4b5a8914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a8914",
  null
  
)

export default component.exports